import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { Row, Col, FormGroup, Radio } from "react-bootstrap";
import _ from "lodash";
import { BASE_IMAGES_URL } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import ImageCropper from "ImageCropper";
import VideoUploader from "VideoUploader";
import LocaleStrings from "Languages";

class WebsiteSettings extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }


  render() {
    return (
      <Row>
        <div className="row">
           {/* <form > */}
          <AddFavIcon {...this.props} />
        {/* </form> */}
        </div>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    // editMode: edit,
    // initialValues: initVals,
    // allSpeakers: state.allSpeakers,
    // interests: state.interests,
    // allCourseName: state.allCourseName,
  };
}

export default connect(mapStateToProps)(WebsiteSettings);


class AddFavIcon extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { imagePreviewUrl: "", videoData: {} };


  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img == "" ? "removed" : img });
    this.props.autofill("coverimagehidden", img);
  };

  onImageChange = (imageAvailable) => {};

  onFilesDrop = (data) => {
    this.setState({ videoData: data == "" ? "removed" : data });
    this.props.autofill("covervideohidden", data);
  };

  onFileAvailable = (changed) => {};

  render() {
    let {
      session,
      editMode,
      initialValues,

    } = this.props;
    let { imagePreviewUrl } = this.state;
    let teachers = [];
    let tags = [];


   

    let tempImage = "";
    let tempVideo = {};
    if (editMode) {
      // Checking cover videos
      if (initialValues.coverimage && initialValues.covervideo) {
        let file = initialValues.covervideo;
        let original = file.split("/").pop();
        let fileName = original;
        let fileObj = { file: file, filename: fileName };

        tempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
        tempVideo = fileObj;
      } else if (initialValues.coverimage && !initialValues.covervideo) {
        tempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
        tempVideo = {};
      } else if (!initialValues.coverimage && initialValues.covervideo) {
        let file = initialValues.covervideo;
        let original = file.split("/").pop();
        let fileName = original;
        let fileObj = { file: file, filename: fileName };

        tempImage = "";
        tempVideo = fileObj;
      }
    }

    if (imagePreviewUrl == "") {
      imagePreviewUrl = tempImage;
    } else if (imagePreviewUrl == "removed") {
      imagePreviewUrl = "";
    }


    return (
      <div className="basicform">
        <div className="form-group">
          <div className="row">
            <div style={{marginLeft: 70,marginTop:15}}>
              <label className="control-label-top">
                {LocaleStrings.site_favicon}
              </label>
              <ImageCropper
                displaySize={{ width: 270, height: 270 }} // For image display style
                requiredSize={{ width: 500, height: 500 }} // For image size required validation
                cropperSize={{ width: 170, height: 170 }} // Cropper display size. Note its add 50px for padding
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                ref={this.cropperRef}
                className="drop-zone-area-custom-favicon"
                insideImage="../../style/images/dummy-image-fill@3x.png"
                insideImageStyle={{
                  width: 36,
                  height: 36,
                  margin: "5px 10px 15px",
                }}
                insideText="Drag and Drop or Click here to upload favicon."
              />
            </div>
          </div>
       </div>
   </div>
    );
  }
}

